// @autogenerated

// WARNING THIS FILE IS AUTOGENERATED! DO NOT EDIT!

import React from 'react';

import H1 from '@govtnz/ds/build/react-ts/H1';
import '../../commons/styles/ds/themed-H1.scss';
import P from '@govtnz/ds/build/react-ts/P';
import '../../commons/styles/ds/themed-P.scss';
import Ul from '@govtnz/ds/build/react-ts/Ul';
import '../../commons/styles/ds/themed-Ul.scss';
import Li from '@govtnz/ds/build/react-ts/Li';
import '../../commons/styles/ds/themed-Li.scss';
import A from '@govtnz/ds/build/react-ts/A';
import '../../commons/styles/ds/themed-A.scss';

import CommunityPage from '../../components/CommunityPage';
import onChangeGenerator from '../../commons/onChangeGenerator';

const PageContent = (props) => <React.Fragment><H1 styleSize="xlarge" id="main-heading">Community</H1>
<P styleSize="large">
    All of Government Services Delivery is creating New Zealand’s New Zealand Government Design System (NZGDS) now. Our
    overall aim is to improve digital service delivery across the New Zealand
    public service.
</P>

<P>Since the NZGDS will be available for everyone in central and local
government — and beyond — to use, we want a strong cross-government community
backing it.</P>
<P>You can contribute by:</P>
<Ul>
<Li>testing our components and patterns</Li>
<Li>helping to develop new components and patterns</Li>
<Li>commenting on our guidance.</Li>
</Ul>
<P>This alpha website shows you what we have built so far, what we&#39;re working on,
and how you can get involved.&nbsp;
<A className="g-link"  href="https://design-system-alpha.digital.govt.nz/">Read about the benefits of using the NZGDS, and how we are building it, on the homepage</A>.</P>
<h2 id="keep-updated">Keep updated</h2>
<P>The input and feedback we received from the initial user research, meetups,
workshop, and user testing has been invaluable in shaping the alpha Design
System.</P>
<P>To keep updated with what we are doing now, what we are planning to do next,
and how you can get involved,&nbsp;
<A className="g-link"  href="https://confirmsubscription.com/h/j/712F84D0A3086D2B">subscribe to the NZGDS newsletter</A>.</P>
</React.Fragment>

const template = (props) => {
    return (
        <CommunityPage
            title="Community"
            pageProps={props}
            PageContent={PageContent}
        />
    );
};

export default template;
